import React from 'react';
import classes from './KcmPage.module.css';
import { BasicContainer } from '../../UI/ContentContainer';
import PageTitle from '../../UI/PageTitle';
import TextContent from '../../UI/TextContent';
import { Box, Typography } from '@mui/material';
import Raw from '../../UI/Text/Raw';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import Table from './Table';

import gear from '../../../assets/img/gear.png';
import { ImageNumberList } from '../../UI/List/List';
import MetaTags from '../../MetaTags/MetaTags';

const target = [
    '연삭기 또는 연마기(휴대형은 제외)',
    '산업용 로봇',
    '혼합기',
    '파쇄기 또는 분쇄기',
    '식품가공용기계(파쇄·절단·혼합·제면기만 해당)',
    '공작기계(선반, 드릴기, 평삭·형삭기, 밀링만 해당)',
    '고정형 목재가공용기계(둥근톱, 대패, 루타기, 띠톱, 모떼기 기계만 해당)',
    '컨베이어',
    '자동차정비용 리프트',
    '인쇄기'
];



const Td = props => {
    return (
        <td {...props}>
            <Typography variant="contentTitleSmall" component="span">{props.children}</Typography>
        </td>
    )
}


const KcmPage = () => {
    return (
        <div>
            <BasicContainer>
                <MetaTags 
                    title="자율안전확인신고"
                    description="자율안전확인신고에 대해 소개 합니다."
                    ogtitle="드림산업안전센터(주)-자율안전확인신고"
                    ogdescription="자율안전확인신고에 대해 소개 합니다."
                />
                    
                <PageTitle title="자율안전확인신고"/>
                <TextContent title="자율안전확인신고" data-aos="fade-up">
                    <Typography variant="description" component="p" sx={{lineHeight: "2"}}>
                        자율안전확인대상 기계·기구 등을 제조하거나 수입하는 자가 해당 제품의 안전에 관한 성능이 자율안전기준에 맞는지 확인하여 고용노동부장관에게 신고하는 제도
                    </Typography>
                    <Raw description="[산업안전보건법 제89조]"/>
                </TextContent>

                <TextContent title="자율안전확인신고 대상 기계" data-aos="fade-up">
                    <ImageNumberList data={target} image={gear} alt="gear.png"/>
                </TextContent>

                <Table data-aos="fade-up" />

                <TextContent title="법적 제재 사항" data-aos="fade-up">
                    <table className={classes['raw-table']}>
                        <caption>
                            <Typography variant="contentTitleSmall" component="p" textAlign="left">산업안전보건법 제170조(벌칙) 및 제171조(벌칙)</Typography>
                        </caption>
                        <thead>
                            <tr>
                                <th><Typography variant="contentTitleSmall" component="span">위반행위</Typography></th>
                                <th><Typography variant="contentTitleSmall" component="span">벌칙</Typography></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <Td>
                                    미신고한 제품, 거짓이나 부정한 방법으로 신고한 제품, 자율안전기준에 부적합한 제품, 자율
                                    안전확인표시의 사용금지 명령을 받은 제품을 제조·수입·양도·대여·사용하거나 양도·대여의
                                    목적으로 진열한 경우
                                </Td>
                                
                                <Td rowSpan="2">
                                    1년 이하의 징역 또는 1천만원 이하의 벌금
                                </Td>
                            </tr>

                            <tr>
                                <Td>
                                    미신고 제품의 수거·파기 명령을 위반한 경우
                                </Td>
                            </tr>
                            <tr>
                                <Td>
                                    자율안전확인대상 제품을 신고하지 않은 경우
                                </Td>
                                <Td rowSpan="4">
                                    1천만원 이하의 벌금
                                </Td>
                            </tr>
                            <tr>
                                <Td>
                                    미신고 제품에 자율안전확인표시 또는 이와 유사한 표시를 하거나 자율안전확인에 관한 광고를 한 경우
                                </Td>
                            </tr>
                            <tr>
                                <Td>
                                    자율안전확인표시를 임의로 변경하거나 제거한 경우
                                </Td>
                            </tr>
                            <tr>
                                <Td>
                                    자율안전확인표시 또는 이와 유사한 표시의 제거 명령을 위반한 경우
                                </Td>
                            </tr>
                        </tbody>
                    </table>

                    <div style={{marginTop: '3rem'}}>
                        <table className={classes['raw-table']} style={{width:'100%', textAlign: 'center'}}>
                            <caption>
                                <Typography variant="contentTitleSmall" component="p" textAlign="left">산업안전보건법 시행령 별표 35(과태료의 부과기준)</Typography>
                            </caption>
                            <thead>
                                <tr>
                                    <th rowSpan="2"><Typography variant="contentTitleSmall" component="span">위반행위</Typography></th>
                                    <th colSpan="3"><Typography variant="contentTitleSmall" component="span">과태료(만원)</Typography></th>
                                </tr>
                                <tr>
                                    <th><Typography variant="contentTitleSmall" component="span">1차</Typography></th>
                                    <th><Typography variant="contentTitleSmall" component="span">2차</Typography></th>
                                    <th><Typography variant="contentTitleSmall" component="span">3차</Typography></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <Td>자율안전확인표시를 하지 않은 경우</Td>                                
                                    <Td>50</Td>
                                    <Td>250</Td>
                                    <Td>500</Td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </TextContent>



            </BasicContainer>
        </div>
    )
}

export default KcmPage;